import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Header from "./components/Header"
import Event from "./pages/Event";
import { LanguageProvider } from "./context/LanguageContext";
import Events from "./pages/Events";
import EventForm from "./pages/EventForm";
import Blogs from "./pages/Blogs";
import Auth from "./pages/Auth";
import BlogDetail from "./pages/BlogDetail";
import Service from "./pages/Service";
import Messages from "./pages/Messages";
import NewMessage from "./pages/NewMessage";
import MessageDetail from "./pages/MessageDetail";
import Account from "./pages/Account";
import Finance from "./pages/Finance";
import FinanceDocument from "./pages/FinanceDocument";
import FinanceChecks from "./pages/FinanceChecks";
import FinanceInvoice from "./pages/FinanceInvoice";

const App = () => {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/:slug" element={<Event />} />
          <Route path="/events/:slug/form" element={<EventForm />} />
          <Route path="/service/:slug" element={<Service />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="/messages/new" element={<NewMessage />} />
          <Route path="/messages/:id" element={<MessageDetail />} />
          <Route path="/account" element={<Account />} />
          <Route path="/finance" element={<Finance />} />
          <Route path="/finance/document/:code" element={<FinanceDocument />} />
          <Route path="/finance/checks/:code" element={<FinanceChecks />} />
          <Route path="/finance/invoice/:code" element={<FinanceInvoice />} />
        </Routes>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;